/**
 * One carryable object, whichever kind it is.
 *
 * The level's `objects` list is kind-agnostic — `buildGeometry` puts a profile's boxes and
 * a maze's table items in the same array on purpose — so the one place that has to know
 * what a kind looks like is here.
 */

import type { PlacedObject } from '../game/profile/buildGeometry';
import { CarryableBox } from './CarryableBox';
import { RobotDogBody, RobotDogLeg } from './RobotDog';
import { Screwdriver } from './Screwdriver';

type Props = {
  object: PlacedObject;
  /** The palette's colour for a cardboard box; other kinds carry their own. */
  boxColor: string;
};

export function CarryableObject({ object, boxColor }: Props) {
  if (object.kind === 'screwdriver') return <Screwdriver object={object} />;
  if (object.kind === 'robot-dog-body') return <RobotDogBody object={object} />;
  if (object.kind === 'robot-dog-leg') return <RobotDogLeg object={object} />;
  return <CarryableBox object={object} color={boxColor} />;
}
